<script lang="ts">
export default { name: "GalleryContainerVue" };
</script>

<script setup lang="ts">
import * as vue from "vue";
import type { GalleryBanner, GalleryImage } from "@/models/gallery";
import GalleryContainerBannerVue from "./GalleryContainerBanner.vue";
import GalleryImageVue from "./GalleryImage.vue";

const props = defineProps({
	banner: {
		type: Object as vue.PropType<GalleryBanner>,
		required: true
	},
	images: {
		type: Array as vue.PropType<GalleryImage[]>,
		required: true
	}
});

const images = vue.computed(() => props.images);
const containerEl = vue.ref<HTMLElement>();
const attrs = vue.useAttrs();

defineExpose({ containerEl });
</script>

<template>
	<div ref="containerEl" class="gallery-container" v-bind="attrs">
		<GalleryContainerBannerVue :banner="banner" />
		<div class="gallery-container__grid">
			<GalleryImageVue v-for="(image, index) in images" :image="image" :key="index" />
		</div>
	</div>
</template>

<style scoped lang="scss">
.gallery-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	justify-content: center;
	width: 100%;
}

.gallery-container__grid {
	column-gap: 1rem;
	width: 80vw;

	@media (max-width: 1024px) {
		column-count: 3;
	}

	@media (min-width: 1025px) {
		column-count: 4;
	}
}

.gallery-container__grid > :deep(.gallery-image-container) {
	break-inside: avoid;
	margin-bottom: 1rem;
}
</style>
